export const handleErrorCode = (errorCode) => {
	const errorDetails = {
		400: { title: 'Bad Request', message: 'Please check your input and try again.' },
		401: { title: 'Unauthorized', message: 'Please login to continue.' },
		403: { title: 'Access Denied', message: 'You do not have permission to access this resource.' },
		404: { title: 'Not Found', message: 'The requested resource could not be found.' },
		500: { title: 'Server Error', message: 'Something went wrong, please try again later.' },
		'InternalError': {
			title: 'Server experienced issue',
			message: 'Please try again',
		},
		'InternalServerError': {
			title: 'Server experienced issue',
			message: 'Please try again',
		},
		'RPEDNotFound': {
			title: 'Nomor Rekening Tidak Ditemukan',
			message: 'Nomor rekening bank yang Anda masukkan tidak ditemukan',
		},
		'BankAccountExists': {
			title: 'Nomor Rekening Sudah Terdaftar',
			message: 'Nomor rekening bank yang Anda masukkan sudah Anda daftarkan sebelumnya',
		},
		'BankAccountNameUnmatch': {
			title: 'Nomor Rekening Tidak Sesuai',
			message: 'Nomor rekening bank yang Anda masukkan tidak sesuai dengan nama peserta pemilik RPED',
		},
		'BankAccountRequestInvalid': {
			title: 'Permintaan Tidak Valid',
			message: 'Mohon ulangi dari awal',
		},
		'BankAccountRequestNotFound': {
			title: 'Permintaan Tidak Valid',
			message: 'Mohon ulangi dari awal',
		},
		'OTPInactiveExpired': {
			title: 'Kode OTP Kedaluarsa',
			message: 'Silakan kirim ulang kode OTP untuk melanjutkan proses',
		},
		'OTPInvalid': {
			title: 'Kode Tidak Sesuai',
			message: 'Kode yang Anda masukkan tidak sesuai. Silakan coba lagi',
		},
		'BankAccountReachedLimit': {
			title: 'Kuota Penyimpanan No. Rekening Penuh',
			message: 'Silakan hapus salah satu jika ingin mengubah atau menambah nomor rekening penarikan baru',
		},
		'OTPResendExceededLimit': {
			title: 'Proses Mencapai Batas',
			message: 'Anda sudah melakukan total 5 kali pengiriman ulang kode OTP. Silakan coba lagi setelah 60 menit',
		},
		// Cash Withdrawal
		'InsufficientBalance': {
			title: 'Saldo RPED Tidak Cukup',
			message: 'Nominal yang Anda masukkan melebihi saldo RPED yang tersedia',
		},
	}

	// Return a mapped error title & message or a generic one
	return errorDetails[errorCode] || null
}